import axios from 'axios'
import qs from 'qs'
import until from './until.js'

const BASE_PATH = process.env.VUE_APP_AFTER_SALES_BASE_PATH || '/api/after_sales'

function authHeaders(contentType) {
    const token = until.getCookie('jwt_token') || ''
    const headers = token ? {
        Authorization: `Bearer ${token}`,
        signature: token
    } : {}
    if (contentType) headers['Content-Type'] = contentType
    return headers
}

function withAppId(appId, params) {
    return Object.assign({ app_id: appId || '' }, params || {})
}

function getErrorMessage(error) {
    const data = error && error.response ? error.response.data : null
    if (data && typeof data === 'object') return data.msg || data.errmsg || data.message || data.error || '请求失败'
    if (typeof data === 'string') {
        const text = data.trim()
        // GoFrame v1 在写入 HTTP 4xx 状态后会先输出状态文本，响应可能形如：
        // Bad Request{"errcode":302,"msg":"具体原因",...}
        // 从首个 JSON 对象开始解析，避免把后端的明确错误降级成“请求失败”。
        const jsonStart = text.indexOf('{')
        const candidates = jsonStart > 0 ? [text, text.slice(jsonStart)] : [text]
        for (const candidate of candidates) {
            try {
                const parsed = JSON.parse(candidate)
                return parsed.msg || parsed.errmsg || parsed.message || parsed.error || '请求失败'
            } catch (e) {
                // 继续尝试剥离 HTTP 状态文本后的 JSON。
            }
        }
        if (text && !/<[a-z][\s\S]*>/i.test(text) && text.length <= 200) return text
        return '请求失败'
    }
    return '网络连接失败，请稍后重试'
}

async function request(config) {
    try {
        const response = await axios(config)
        return response.data || { errcode: 1, errmsg: '响应数据为空' }
    } catch (error) {
        return {
            errcode: 1,
            status: error && error.response ? error.response.status : 0,
            errmsg: getErrorMessage(error)
        }
    }
}

function requestId() {
    if (until.guid) return `mobile-${until.guid()}-${Date.now()}`
    return `mobile-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export default {
    resolveDevice(appId, rawCode) {
        return request({
            method: 'post',
            url: `${BASE_PATH}/device/resolve`,
            params: withAppId(appId),
            data: qs.stringify({ raw_code: rawCode }),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },

    registerDevice(appId, data) {
        return request({
            method: 'post',
            url: `${BASE_PATH}/device/register`,
            params: withAppId(appId),
            data: qs.stringify(Object.assign({ request_id: requestId() }, data || {})),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },

    printLabel(appId, data) {
        return request({
            method: 'post',
            url: `${BASE_PATH}/device/label/print`,
            params: withAppId(appId),
            data: qs.stringify(Object.assign({ request_id: requestId() }, data || {})),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },

    createIntake(appId, data) {
        return request({
            method: 'post',
            url: `${BASE_PATH}/intake`,
            params: withAppId(appId),
            data: qs.stringify(Object.assign({ request_id: requestId() }, data || {})),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },

    getWorkflow(appId, orderId) {
        return request({
            method: 'get',
            url: `${BASE_PATH}/workflow`,
            params: withAppId(appId, { order_id: orderId }),
            headers: authHeaders()
        })
    },

    listWorkflow(appId, params) {
        return request({
            method: 'get',
            url: `${BASE_PATH}/workflow/list`,
            params: withAppId(appId, params || {}),
            headers: authHeaders()
        })
    },

    submitDiagnosis(appId, data) {
        return request({
            method: 'post',
            url: `${BASE_PATH}/workflow/diagnosis`,
            params: withAppId(appId),
            data: qs.stringify(Object.assign({ request_id: requestId() }, data || {})),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },

    updateRepair(appId, data) {
        return request({
            method: 'post',
            url: `${BASE_PATH}/workflow/repair`,
            params: withAppId(appId),
            data: qs.stringify(Object.assign({ request_id: requestId() }, data || {})),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },

    submitQc(appId, data) {
        return request({
            method: 'post',
            url: `${BASE_PATH}/workflow/qc`,
            params: withAppId(appId),
            data: qs.stringify(Object.assign({ request_id: requestId() }, data || {})),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },

    submitDisposition(appId, data) {
        return request({
            method: 'post',
            url: `${BASE_PATH}/workflow/disposition`,
            params: withAppId(appId),
            data: qs.stringify(Object.assign({ request_id: requestId() }, data || {})),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },

    submitShipment(appId, data) {
        return request({
            method: 'post',
            url: `${BASE_PATH}/workflow/shipment`,
            params: withAppId(appId),
            data: qs.stringify(Object.assign({ request_id: requestId() }, data || {})),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },

    uploadImage(appId, file, data) {
        const formData = new FormData()
        formData.append('file', file)
        Object.keys(data || {}).forEach(key => {
            if (data[key] !== undefined && data[key] !== null) formData.append(key, data[key])
        })
        return request({
            method: 'post',
            url: `${BASE_PATH}/upload`,
            params: withAppId(appId),
            data: formData,
            headers: authHeaders()
        })
    }
}
